import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { EventsPage } from "./pages/EventsPage.js";
import { LoginPage } from "./pages/LoginPage.js";
import { ScanPage } from "./pages/ScanPage.js";
import { StagePickerPage } from "./pages/StagePickerPage.js";
import { useAuth } from "./store/auth.js";

function Protected({ children }: { children: JSX.Element }): JSX.Element {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" replace />;
}

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/events"
        element={
          <Protected>
            <EventsPage />
          </Protected>
        }
      />
      <Route
        path="/scan/:eventId"
        element={
          <Protected>
            <ScanPage />
          </Protected>
        }
      />
      {/* CR-04: stage picker, shown when the operator covers 2+ stages. */}
      <Route
        path="/scan/:eventId/select-stage"
        element={
          <Protected>
            <StagePickerPage />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
